var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8024_28631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 24.5H6.125C5.89294 24.5 5.67038 24.4078 5.50628 24.2437C5.34219 24.0796 5.25 23.8571 5.25 23.625V7.875C5.25 7.64294 5.34219 7.42038 5.50628 7.25628C5.67038 7.09219 5.89294 7 6.125 7H14.875L19.25 11.375V23.625C19.25 23.8571 19.1578 24.0796 18.9937 24.2437C18.8296 24.4078 18.6071 24.5 18.375 24.5Z",
    stroke: "#655CFE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 7V4.375C8.75 4.14294 8.84219 3.92038 9.00628 3.75628C9.17038 3.59219 9.39294 3.5 9.625 3.5H18.375L22.75 7.875V20.125C22.75 20.3571 22.6578 20.5796 22.4937 20.7437C22.3296 20.9078 22.1071 21 21.875 21H19.25",
    stroke: "#655CFE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.625 16.625H14.875",
    stroke: "#655CFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.625 20.125H14.875",
    stroke: "#655CFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8024_28631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.2bf27536facb4789acb9cd583a8b45ae.svg";
export { ForwardRef as ReactComponent };